import { ForecastingDataContextProvider } from 'src/features/Forecasting/contexts/ForecastingDataContext/ForecastingDataContextProvider';
import { NoSubscriptionPage } from '../NoSubscriptionPage';
import { ForecastPage } from './ForecastPage';

type ForecastingPagesProps = {
  isSubscribed: boolean;
};

export const ForecastingPages: React.FC<ForecastingPagesProps> = ({
  isSubscribed,
}) => {
  if (!isSubscribed) {
    return <NoSubscriptionPage service="Forecasting" />;
  }

  return (
    <ForecastingDataContextProvider>
      <ForecastPage />
    </ForecastingDataContextProvider>
  );
};
